import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { ChangePassWord } from '../models/change-password.model';
import { HttpService } from '@app/core/services/http/http.service';

@Injectable()
export class ChangePassWordService {
  static readonly url = 'ChangePasswordManager/';

  constructor(private httpService: HttpService) { }

  static MatchPassword(AC: AbstractControl) {
    const password = AC.get('newPassword').value; // to get value in input tag
    const confirmPassword = AC.get('confirmPassword').value; // to get value in input tag
    if (password === confirmPassword) {
      return null;
    }

    AC.get('confirmPassword').setErrors({ MatchPassword: true });
  }

  ChangePasswordDeliveryOrWebapp(changePassWord: ChangePassWord) {
    const url = `${ChangePassWordService.url}ChangePasswordDeliveryOrWebapp`;

    return this.httpService.PostRequest<any, ChangePassWord>(url, changePassWord);
  }
}
